import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FnFiltersModalComponent } from '../fn-filters-modal/fn-filters-modal.component';
import IpErrorResponse from 'src/app/invopay/interfaces/ip-error-response';
import { combineLatest, Observable, Subscription } from 'rxjs';
import FinSupplierAccountRow from 'src/app/invopay/interfaces/fin-supplier-account-row';
import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { TableService } from 'src/app/invopay/types/ip-table-service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { IPagination } from 'src/app/shared/models/pagination';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { IpSupplierService } from 'src/app/invopay/services/ip-supplier.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';
import { IpCurrencyService } from 'src/app/invopay/services/ip-currency.service';
import { AmountFormatPipe } from 'src/app/shared/Utils/amount-format-pipe.pipe';
import { FnAccountFinanceService } from 'src/app/invopay/services/fn-account-finance.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TableEvent } from 'src/app/shared/components/table/Itable';
import FilterValues from 'src/app/invopay/interfaces/ip-filter-values';
import Pageable from 'src/app/invopay/interfaces/ip-pageable';

import InvoiceRow from 'src/app/invopay/interfaces/ip-invoice-row';
import { IpTableBillService } from 'src/app/invopay/services/ip-table-bill.service';
import { TransformDataTablePipe } from 'src/app/shared/Utils/transform-data-table.pipe';
import { DatePipe } from '@angular/common';
import { FnConsolidatedService } from '../../services/fn-consoldate.service';
import { CustomDatePipe } from 'src/app/shared/Utils/pipeCustomDate';
import { ActivatedRoute } from '@angular/router';
import { MatDrawerMode } from '@angular/material/sidenav';

@Component({
  selector: 'app-fn-tables',
  templateUrl: './fn-tables.component.html',
  styleUrls: ['./fn-tables.component.scss'],
  providers: [CustomDatePipe],
})
export class FnTablesComponent implements OnInit, OnChanges, OnDestroy {
  @Input() noData: string = '';
  @Input() Date: string = '';
  @Input() supplierId!: number | undefined;
  @Input() propertyOrder: string[] = [];
  @Input() tableTitle!: string;
  @Input() pageItems!: number;
  @Input() tableOption!: TableOption;
  @Input() service!: TableService;
  @Input() dataChange!: Observable<void>;
  @Input() onlyLast30days: boolean = false;
  @Input() ignoredTypeStatus?: number;
  @Input() billed?: boolean | undefined = false;
  @Input() optionalTitle?: string;
  @Input() dataOptional?: any;
  @Input() isForSelectedItem?: boolean;
  @Input() consolidatedStep?: boolean;
  @Input() dateFiltersActive?: boolean = true;
  @Input() totalsForConsolidated: any;
  @Input() searchField= true;

  selectedInvoicesList: any = [];

  @Output() invoicesSelected = new EventEmitter<any[]>();
  @Output() dataOk = new EventEmitter<any>();

  maxDate!: string;
  minEndDate!: string;
  datesForm!: FormGroup;

  get creationDate() {
    return this.datesForm.get('creationDate') as FormControl;
  }

  get dueDate() {
    return this.datesForm.get('dueDate') as FormControl;
  }

  type!: 'business' | 'employee' | 'provider';
  data?: any[];
  sortOrder: string = '';
  sortFieldName: string = '';
  pagination!: IPagination;
  totalItems!: number;
  dataChangeSubscription!: Subscription;
  typeStatus: string | Function = '';
  statusCode: string | Function = '';
  currentPage: number = 0;
  test: TableService = 'invoice';
  mode?: MatDrawerMode;
  @ViewChild('modalFilters') dialogTemplate!: TemplateRef<any>;
  dialogFiltersRef!: MatDialogRef<any>;

  constructor(
    private roleService: IpRoleService,
    private ipSupplierService: IpSupplierService,
    private ipSnackbarService: IpSnackbarService,
    private ipCurrencyService: IpCurrencyService,
    private tableBillService: IpTableBillService,
    private route: ActivatedRoute,
    private amountFormatPipe: AmountFormatPipe,
    private fnAccountFinanceService: FnAccountFinanceService,
    private consolidatedService: FnConsolidatedService,
    private transformDataTablePipe: TransformDataTablePipe,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private customDate: CustomDatePipe,
    private datePipe: DatePipe
  ) {this.updateMode(window.innerWidth)}

  ngOnInit(): void {
    this.type = this.roleService.getType();
    this.pagination = {
      page: 0,
      size: this.pageItems,
    };
    if (this.dataChange) {
      this.dataChangeSubscription = this.dataChange.subscribe({
        error: console.log,
        next: () => this.executeService(),
      });
    }

    // FORM
    this.datesForm = this.fb.group({
      creationDate: [''],
      dueDate: [''],
    });

    this.executeService();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalsForConsolidated']){
      this.executeService()
    }
  }

  ngOnDestroy() {
    if (this.dataChangeSubscription) {
      this.dataChangeSubscription.unsubscribe();
    }
  }

  // Table sorting - Logic
  onSortTable = (event: TableEvent) => {
    this.currentPage = 0;
    this.pagination.page = 0;
    if (event.event == 'clean') {
      this.sortOrder = '';
      this.sortFieldName = '';
    } else {
      this.sortOrder = event.event;
      this.sortFieldName = event.key ?? '';
    }
    this.executeService();
  };

  // Table action - Logic
  @Output() action: EventEmitter<TableEvent> = new EventEmitter<TableEvent>();

  onActionTable = (event: TableEvent) => this.action.emit(event);

  checkValue(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const labelElement = inputElement.nextElementSibling as HTMLElement;

    if (inputElement.value) {
      labelElement.style.display = 'none';
    } else {
      labelElement.style.display = 'block';
    }
  }

  onInvoiceSelectionChange(newSelection: any) {
    this.selectedInvoicesList = newSelection;
    // Emitimos la lista actualizada al componente padre
    this.invoicesSelected.emit(this.selectedInvoicesList);
  }

  // Table selects - Logic
  currentSelect: number = 0;
  toggleSelect = (
    selectPosition: number,
    select: [string, string | Function]
  ) => {
    this.currentSelect = selectPosition;
    this.typeStatus = select[1];
    this.statusCode = select[1];
    this.currentPage = 0;
    this.pagination.page = 0;
    // Search reset
    this.searchValue = '';
    this.executeService();
  };

  // Search - Logic
  searchValue: string = '';

  onSearch(searchValue: string) {
    this.searchValue = searchValue;
    this.executeService();
  }

  onPageChange(page: number): void {
    this.currentPage = page - 1;
    this.pagination.page = this.currentPage;
    this.executeService();
  }

  // Filter menu - Logic
  @Input() filter: boolean = false;
  showFilter: boolean = false;
  filterValues: FilterValues = {};

  toggleFilter = (state: boolean) => (this.showFilter = state);

  setFilters = (event?: any) => {
    this.filterValues.amountFrom = event.amountFrom;
    this.filterValues.amountTo = event.amountTo;
    this.filterValues.createDateFrom = event.dateFrom;
    // Creation date filters cannot be altered on this case
    if (!this.onlyLast30days) {
      this.filterValues.createDateFrom = event.dateFrom;
      this.filterValues.createDateTo = event.dateTo;
    }

    this.executeService();
  };

  onStartDateChange() {
    if (this.creationDate) {
      const startDate = new Date(this.creationDate.value);

      this.minEndDate = startDate.toISOString().split('T')[0];
    } else {
      this.dueDate?.setValue('');
    }
  }

  onFinishDateChange(){
    const endDate = new Date(this.dueDate.value);
    this.maxDate = endDate.toISOString().split('T')[0]
  }

  openCalendar(DateInput: HTMLInputElement): void {
    setTimeout(() => {
      DateInput.click();
    }, 100);
  }

  // Service calls
  executeService(searchValue?: string) {
    const pageable: Pageable = { ...this.pagination };
    if (this.sortFieldName && this.sortOrder) {
      pageable.sort = `${this.sortFieldName},${this.sortOrder}`;
    }
    let searchName = '';
    let startDate = '';
    let endDate = '';
    if (this.creationDate?.value) {
      startDate = this.formatStartDate(this.creationDate.value);
    }
    if (this.dueDate?.value) {
      endDate = this.formatEndDate(this.dueDate.value);
    }
    this.onClose()
    switch (this.service) {
      case 'supplier-accounts':
        combineLatest({
          currencies: this.ipCurrencyService.currencies$,
          supplierAccounts: this.fnAccountFinanceService.getSupplierAccounts(
            this.pagination,
            ''
          ),
        }).subscribe({
          next: ({ currencies, supplierAccounts }) => {
            if (currencies) {
              const newData: Array<FinSupplierAccountRow> = [];
              supplierAccounts.content.forEach((supplierAccount: any) => {
                const supplierAccountRow: FinSupplierAccountRow = {
                  ...supplierAccount,
                  formattedCardBalance: supplierAccount.cardBalance.toString(),
                  formattedAccountBalance:
                    supplierAccount.accountBalance.toString(),
                };
                const foundCurrency = currencies.find((currency: any) => {
                  // TODO: GET real currency
                  return currency.code === 'ARS';
                });
                if (foundCurrency) {
                  const formattedCardBalance = this.amountFormatPipe.transform(
                    supplierAccount.cardBalance,
                    foundCurrency.isCommaFloat,
                    foundCurrency.symbol
                    // foundCurrency.code
                  );
                  const formattedAccountBalance =
                    this.amountFormatPipe.transform(
                      supplierAccount.accountBalance,
                      foundCurrency.isCommaFloat,
                      foundCurrency.symbol
                      // foundCurrency.code
                    );
                  supplierAccountRow.formattedCardBalance =
                    formattedCardBalance;
                  supplierAccountRow.formattedAccountBalance =
                    formattedAccountBalance;
                }
                newData.push(supplierAccountRow);
              });
              this.data = newData;
              this.totalItems = supplierAccounts.totalElements;
            }
          },
          error: (e: IpErrorResponse) => {
            this.ipSnackbarService.showErrorMessage(e);
          },
        });
        break;
      case 'account-transactions':
        this.fnAccountFinanceService
          .getAccountMovements(
            this.pagination,
            startDate,
            endDate,
            this.supplierId
          )
          .subscribe({
            next: (data: any) => {
              this.data = data.content;
              this.totalItems = data.totalElements;
            },
            error: (e: IpErrorResponse) => {
              this.ipSnackbarService.showErrorMessage(e);
            },
          });
        break;
      case 'card-transactions':
        this.fnAccountFinanceService
          .getCardMovements(
            this.pagination,
            startDate,
            endDate,
            this.supplierId
          )
          .subscribe({
            next: (data: any) => {
              this.data = data.content;
              this.totalItems = data.totalElements;
            },
            error: (e: IpErrorResponse) => {
              this.ipSnackbarService.showErrorMessage(e);
            },
          });
        break;
      case 'supplier-users':
        this.ipSupplierService.getSupplierUsers(pageable).subscribe({
          next: (data: any) => {
            this.data = data.content;
            this.totalItems = data.totalElements;
          },
          error: (e: IpErrorResponse) => {
            this.ipSnackbarService.showErrorMessage(e);
          },
        });
        break;
      case 'consolidated-detail':
        this.route.paramMap.subscribe((params) => {
          const consoId = Number(params.get('consolidatedId'));
          this.consolidatedService.getConsolidateDetails(consoId).subscribe({
            next: (response) => {
              const dataValues: any[] = [];
              response.content.forEach((val: any) => {
                const value = {
                  id: val.id,
                  provider_name: val.businessName,
                  broker_name: val.brokerName,
                  cuit: val.fiscalId,
                  id_consolidated: val.consolidatedId,
                  invoices_total: val.totalInvoices,
                  amount: val.amount,
                  bank: val.bank,
                  branch_number: val.branchNumber,
                  owner_name: val.ownerName,
                  accnumber: val.accountNumber,
                  is_paid: val.isPaid
                };
                dataValues.push(value);
              });
              this.data = dataValues;
              this.totalItems = dataValues.length;
              this.dataOk.emit()
            },
          });
        });
        break;
      case 'invoice-to-pay':
        if ( this.creationDate?.value === '' && this.dueDate?.value === ''){
          const today = new Date();          
          this.creationDate?.patchValue(this.formatDate(this.firstDay(today)))
          this.dueDate?.patchValue(this.formatDate(today))
        }
        this.consolidatedService
          .getInvoicesToPay(
            this.pagination,
            this.creationDate!.value
              ? this.creationDate!.value + 'T00:00:00'
              : '',
            this.dueDate!.value ? this.dueDate!.value + 'T00:00:00' : '',
            searchValue ?? ''
          )
          .subscribe({
            next: (data: any) => {
              console.log(data.content);
              
              const dataValues: any[] = [];
              data.content.forEach((val: any) => {
                const value = {
                  select_all: val.invoiceId,
                  provider_name: val.businessName,
                  broker_name: val.brokerName,
                  charge_date: this.customDate.transform(val.loadingDate),
                  emit_date: this.customDate.transform(val.creationDate),
                  expired_date: this.customDate.transform(val.dueDate),
                  amount: val.amount,
                  invoiceId: val.invoiceId,
                  supplierId: val.supplierId,
                  invoices: val.invoiceToPay,
                  active: val.active,
                };
                dataValues.push(value);
              });
              this.data = dataValues;
              this.totalItems = dataValues.length;
            },
          });
        break;
      case 'invoice':
        if (this.type === 'business') {
          searchName = 'fiscalIdOrSupplierName';
        }
        // Sort replacements
        if (this.sortFieldName === 'supplierName') {
          this.sortFieldName = 'supplierBusinessName';
        }

        combineLatest({
          currencies: this.ipCurrencyService.currencies$,
          invoices: this.tableBillService.getData(
            this.type,
            this.pagination,
            this.sortFieldName,
            this.sortOrder,
            searchName,
            this.searchValue,
            this.filterValues,
            Number(this.typeStatus)
          ),
        }).subscribe({
          next: ({ currencies, invoices }) => {
            if (currencies) {
              const newData: Array<InvoiceRow> = [];
              invoices.content.forEach((invoice: any) => {
                if (invoice.typeStatus.isPayable) {
                  const newInvoice: any = {
                    select_all: '#' + invoice.fiscalId,
                    provider_name: invoice.supplierName,
                    charge_date: this.transformDataTablePipe.transform(
                      invoice.loadingDate,
                      'Date',
                      ''
                    ),
                    emit_date: this.transformDataTablePipe.transform(
                      invoice.creationDate,
                      'Date',
                      ''
                    ),
                    expired_date: this.transformDataTablePipe.transform(
                      invoice.dueDate,
                      'Date',
                      ''
                    ),
                    supplierId: invoice.supplierId,
                    amount: invoice.totalAmount,
                  };

                  newData.push(newInvoice);
                }
              });
              this.data = newData;

              this.totalItems = invoices.totalElements;
            }
          },
          error: (e: IpErrorResponse) => {
            this.ipSnackbarService.showErrorMessage(e);
          },
        });
        break;
      case 'consolidated-template':
        const dataValues: any[] = [];
        console.log(this.totalsForConsolidated?.invoiceToPay);
        
        this.totalsForConsolidated?.invoiceToPay.forEach((val: any) => {
          const value = {
            broker_name: val.brokerName,
            cuit: val.fiscalId,
            amount: val.totalAmount,
            invoices_total: val.totalInvoices,
            invoices: val.invoices,
            bank: val.bank,
            branch_number: val.branchNumber,
            owner_name: val.ownerName,
            accnumber: val.accountNumber
          };
          dataValues.push(value);
        });
        this.data = dataValues;
        this.totalItems = dataValues.length;
        break;
      default:
        console.warn('No service defined.');
        this.data = [];
        break;
    }
  }

  openFiltersModal() {
    const dialogRef = this.dialog.open(FnFiltersModalComponent, {
      height: 'max-content',
      width: '90%',
      maxWidth: 'none',
      panelClass: 'custom-modal',
      data: {
        optionalTitle: this.optionalTitle,
        hideSearchBox:
          this.service === 'account-transactions' ||
          this.service === 'card-transactions',
        startDate: this.creationDate?.value,
        endDate: this.dueDate?.value,
        searchValue: this.searchValue,
      },
    });

    dialogRef.afterClosed().subscribe((dates) => {
      if (
        dates &&
        (dates.startDate !== this.creationDate?.value ||
          dates.endDate !== this.dueDate?.value) &&
        this.searchValue !== ''
      ) {
        this.creationDate?.setValue(dates.startDate);
        this.dueDate?.setValue(dates.endDate);
        this.executeService(this.searchValue);
      }
    });

    dialogRef.disableClose = true;
  }

  formatStartDate(date: string): string {
    const day = this.datePipe.transform(date, 'dd');
    const month = this.datePipe.transform(date, 'MM');
    const year = this.datePipe.transform(date, 'yyyy');
    return `${year}-${month}-${day}T00:00:00`;
  }

  formatEndDate(date: string): string {
    const day = this.datePipe.transform(date, 'dd');
    const month = this.datePipe.transform(date, 'MM');
    const year = this.datePipe.transform(date, 'yyyy');
    return `${year}-${month}-${day}T23:59:59`;
  }

  formatDate(date:Date) {
    const fechaISO = date.toISOString();
    return fechaISO.split('T')[0]; 
  }

  firstDay(date:Date) {
    const newDate = new Date(date); 
    newDate.setDate(1);
    return newDate;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.updateMode(event.target.innerWidth);
  }

  private updateMode(windowWidth: number) {
    if (windowWidth >= 768) {
      this.mode = 'side';
    } else {
      this.mode = 'over';
    }
  }

  openDialog() {
    this.dialogFiltersRef = this.dialog.open(this.dialogTemplate);
  }

  onClose(){
    if(this.dialogFiltersRef){
      this.dialogFiltersRef.close()
    }
  }
}
